import { render, staticRenderFns } from "./TheWindowHeader.vue?vue&type=template&id=90f56d30&scoped=true"
import script from "./TheWindowHeader.vue?vue&type=script&lang=js"
export * from "./TheWindowHeader.vue?vue&type=script&lang=js"
import style0 from "./TheWindowHeader.vue?vue&type=style&index=0&id=90f56d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f56d30",
  null
  
)

export default component.exports